import { render, staticRenderFns } from "./SettingPeople.vue?vue&type=template&id=3af1c311&scoped=true&"
import script from "./SettingPeople.vue?vue&type=script&lang=js&"
export * from "./SettingPeople.vue?vue&type=script&lang=js&"
import style0 from "./SettingPeople.vue?vue&type=style&index=0&id=3af1c311&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1c311",
  null
  
)

export default component.exports